<script lang="ts">
    import { Tabs as TabsPrimitive } from "bits-ui";
    import { cn } from "../../../utils.js";

    let {
        ref = $bindable(null),
        value = $bindable(""),
        class: className,
        ...restProps
    }: TabsPrimitive.RootProps = $props();
</script>

<TabsPrimitive.Root bind:ref bind:value data-slot="tabs" class={cn("flex flex-col", className)} {...restProps} />
